import {Elements} from "@stripe/react-stripe-js";
import {stripePromise} from "../../../App";
import {useEffect, useState} from "react";
import {useProposal} from "../../../hooks/useProposal";
import {Outlet, Route, useParams, useSearchParams} from "react-router-dom";
import PaymentSheet from "./stripePayment";
import CompletePage from "./completePage";
import {useTranslation} from "react-i18next";
import {useUpdateIntervention} from "../../../hooks/useInterventions";

const InterventionPaymentPage = () => {
  const {id: interventionId} = useParams();
  const [search, setSearchparams] = useSearchParams();
  const amount = search.get("amount");

  const [clientSecret, setClientSecret] = useState("");
  // const [amount, setAmount] = useState(null);
  const {onPayIntervention} = useUpdateIntervention();
  const {t} = useTranslation();
  useEffect(() => {
    async function fetchData() {
      // Call your backend to create the PaymentIntent
      // Set the client secret to the state
      const response = await onPayIntervention({interventionId});

      // const data = await response.json();

      // if (!data.success) {
      //   throw new Error("Failed to create payment intent");
      // }

      const {paymentIntent} = response;
      setClientSecret(paymentIntent.client_secret);
      // setAmount(paymentIntent.amount);
    }
    if (!interventionId) {
      const clientSecret = new URLSearchParams(window.location.search).get(
        "payment_intent_client_secret"
      );
      setClientSecret(clientSecret);
      return;
    }
    fetchData();
  }, [interventionId]);
  const appearance = {
    theme: "stripe",
  };
  // Enable the skeleton loader UI for optimal loading.
  const loader = "auto";
  return (
    <>
      <div className="w-full h-full flex  flex-col justify-center items-center">
        {amount !== null && (
          <p className="text-lg font-bold mb-4">
            {t("AmountToPay")}: €{Number(amount).toFixed(2)}{" "}
            {/* Assuming cents */}
          </p>
        )}
        {!!clientSecret && (
          <Elements
            options={{clientSecret, appearance, loader}}
            stripe={stripePromise}
          >
            <Outlet />
          </Elements>
        )}
      </div>
    </>
  );
};

export default InterventionPaymentPage;
